// extracted by css-extract-rspack-plugin
var _1 = "_z71KFAkhPA7UNMd";
var _2 = "_z71KFAkhPA7UNMd";
export { _1 as "nav-menu", _2 as "navMenu" }
